import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import getUsersTransformer from './transformers/staff/usersTransformer';
import User from '@/models/user';
import apiClient from '@/apiClient';

type passwordRecoveryPayload = {
  id: string;
  password: string;
  passwordConfirmation: string;
  oldPassword: string;
};

export default {
  async fetchStaffs() {
    return window.axios.get('/staff/list', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getUsersTransformer()
    });
  },
  async editStaff(staff: User) {
    return window.axios.patch('/staff/edit', staff, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async sendInvite(user: any) {
    return window.axios.post('/staff/invite', user, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async uploadImage(file: Blob): Promise<any> {
    const formData = new FormData();

    formData.append('menuitem_image[file]', file);

    return window.axios({
      method: 'POST',
      url: '/menu/image/upload',
      data: formData,
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  async checkImageIsExist(payload: { file: Blob, hash: string }): Promise<any> {
    return window.axios.post('/menu/image/check', payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editPassword({ id, ...payload }: passwordRecoveryPayload) {
    return apiClient.patch(`/staff/change/password/${id}`, payload, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async cancelInvite(staffId: string) {
    return window.axios.delete(`/staff/delete/${staffId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeMessageFromClientChat(messageId: string) {
    return window.axios.delete(`/client/message/delete/${messageId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async updateAvailableSections(staffId: string, updatedFields: any) {
    return window.axios.post(`/staff/available-sections/new/${staffId}`, updatedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeStaff(staffId: string) {
    return apiClient.delete(`/staff/delete/${staffId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeStaffInvite(staffId: string) {
    return apiClient.delete(`/staff/delete-invite/${staffId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  }
};
